import Vue from 'vue'
import PrismicVue from '@prismicio/vue'
import linkResolver from './prismic/link-resolver'
import htmlSerializer from './prismic/html-serializer'
import App from './App.vue'
import router from './router'
// Custom Imported
import vueDebounce from 'vue-debounce'
import './../node_modules/bulma/css/bulma.css';
import './../src/assets/css/tutorial/main.css';
import './../src/assets/themes/prism-cb.css';
// import './../src/assets/css/custom.css';
import './../src/assets/fonts/style.css';
// register jw pagination component globally
import VueMeta from 'vue-meta';
// import json from '../json/main.json';

const endpoint = 'https://pepipost.cdn.prismic.io/api/v2';

Vue.use(VueMeta, {
// optional pluginOptions
  // refreshOnceOnNavigation: true
})

Vue.config.productionTip = false

Vue.use(PrismicVue, {
  endpoint: endpoint,
  linkResolver,
  htmlSerializer
})

Vue.use(vueDebounce);

// Text clip filter
var filter = function(text, length, clamp){
    clamp = clamp || '...';
    var node = document.createElement('div');
    node.innerHTML = text;
    var content = node.textContent;
    return content.length > length ? content.slice(0, length) + clamp : content;
};

Vue.filter('truncate', filter);

Vue.use(PrismicVue, {
  endpoint,
  apiOptions: { router },
})

const root = new Vue({
  router,
  render: h => h(App)
})

document.addEventListener('DOMContentLoaded', () => {
  if (document.getElementById('app') !== null) {
    root.$mount('#app');
  } else {
      // <div id="app"> was removed due to prerendering
    root.$mount('body > div');
  }
  // document.dispatchEvent(new Event('render-completed'));
})
